<span class="font-weight-bold" [ngClass]="{'color-green': statusValue == '1' }">{{text}}</span>
